import {Component, OnInit} from '@angular/core';
import {HttpClientService} from "../../core/services/http-client.service";
import {AffiliateService} from "../../core/services/affiliate.service";
import {CommonService} from "../../core/services/common.service";
import {ToastService} from "../../core/services/toast.service";

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.css']
})
export class ReferralComponent implements OnInit{
   customer: any;
   userCode: string;
   referralCode:string;
   referredUsers: any;
  constructor(private httpService: HttpClientService, private affiliateService: AffiliateService, private common: CommonService,private toast:ToastService) {
    this.customer = this.common.getStorage('customer');
    this.userCode = this.customer.firstName.charAt(0).toUpperCase() + this.customer.lastName.charAt(0).toUpperCase();
    this.referralCode=this.userCode+this.customer.id;
  }

  stats = [
    { title: 'Total Referrals', value: '0', icon: 'people', color: 'danger' },
    { title: 'Verified Referrals', value: '0', icon: 'check-circle', color: 'success' },
    { title: 'Pending Verification', value: '0', icon: 'clock', color: 'warning' },
    { title: 'Referral Earning', value: '0', icon: 'wallet-fill', color: 'primary' }
  ];

  rewards = [
    { title: 'Referral Signup Bonus', date: 'Oct 15, 2025', amount: '+₹500.00' },
    { title: 'First Sale Commission', date: 'Oct 20, 2025', amount: '+₹250.00' },
    { title: 'Monthly Bonus', date: 'Nov 1, 2025', amount: '+₹300.00' }
  ];
  ngOnInit(): void {
    this.getRefferedUSer();
  }

  getRefferedUSer() {
    this.affiliateService.getReferredUser(this.referralCode).subscribe({
      next: (res) => {
        this.referredUsers=res.response;
        console.log("Getting the referred user here",res);
        this.stats[0].value = res.response?.length || 0;
        // this.stats[1].value = res.response?.length || 0;
        this.stats[2].value = res.response.affiliateOrders?.length || 0;
        this.stats[3].value = String((res.response?.length) * 100 || 0);

      },
      error: (err) => {
        console.error("Error loading stats", err);
      }
    });
  };
  copyToClipboard(text: string) {
    text = "Hi! I have joined as SmartSeller with SmartDukaan. Check out this referral code to become a smart-seller! \n"+text;
    navigator.clipboard.writeText(text).then(() => {
      this.toast.success("Link Copied to clipboard successfully")
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }

}
